var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-main',[_c('div',{staticClass:"home"},[_c('div',{staticClass:"subheader"},[_c('div',{staticClass:"subheader-main"},[_c('h3',[_vm._v(" "+_vm._s(_vm.$t('labels.statistics'))+" ")]),_c('span',{staticClass:"separator-line"}),_c('div',{staticClass:"breadcrumbs"},[_c('router-link',{staticClass:"breadcrumbs-link",attrs:{"to":"/"}},[_vm._v(" "+_vm._s(_vm.$t('labels.home')))]),_c('span',{staticClass:"separator-dot"}),_c('router-link',{staticClass:"breadcrumbs-link",attrs:{"to":"/tickets/statistics-new"}},[_vm._v(" "+_vm._s(_vm.$t('labels.statistics')))])],1),_c('div',{staticClass:"ml-auto d-flex justify-content-center"},[_c('info-box',{staticClass:"mx-3 mt-1",attrs:{"field":"Ärenden avd Statistik - toggle ärenden/händelser"}}),_c('b-form-group',[_c('b-form-radio-group',{attrs:{"id":"toggle-statistics","options":_vm.statistics,"button-variant":"outline-primary","buttons":""},on:{"change":_vm.switchStatistic},model:{value:(_vm.selectedStatistic),callback:function ($$v) {_vm.selectedStatistic=$$v},expression:"selectedStatistic"}})],1)],1)])]),_c('reactive-base',{attrs:{"app":"ticket_index","credentials":_vm.user.user.es_username + ':' + _vm.user.user.es_password,"url":_vm.elasticUrl}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"widget"},[_c('div',{staticClass:"widget-header statistics-filter"},[_c('div',{staticClass:"widget-header-label"},[_c('h3',[_vm._v(_vm._s(_vm.$t('labels.selected-filters')))])]),_c('div',{staticClass:"widget-header-toolbar"},[_c('div',{staticClass:"actions"},[_c('SelectedFilters',{staticClass:"bb-1 curent-filters pl-4 m-0",attrs:{"clearAllLabel":this.$t('labels.clear')}})],1)])])])]),_c('v-guard',{attrs:{"permissions":['tickets-page-statistics-use-filter']}},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"widget"},[_c('div',{staticClass:"widget-header statistics-filter"},[_c('multi-list',{attrs:{"componentId":"yearFilter","filterLabel":this.$t('labels.year'),"title":this.$t('labels.year-ticket-registered'),"dataField":"year.raw","className":"horizontal-filter year-filter","sortBy":"asc","showSearch":false,"URLParams":true,"react":{ and: _vm.getOtherFilterIds('yearFilter') }},on:{"valueChange":_vm.setSelectedYears},scopedSlots:_vm._u([{key:"renderItem",fn:function(ref){
var label = ref.label;
return [_c('div',[_vm._v(_vm._s(label))])]}}])}),_c('multi-list',{attrs:{"componentId":"quarterFilter","filterLabel":this.$t('labels.quarter'),"title":this.$t('labels.quarter-ticket-registered'),"dataField":"quarter.raw","className":"horizontal-filter quarter-filter","sortBy":"asc","showSearch":false,"URLParams":true,"react":{ and: _vm.getOtherFilterIds('quarterFilter') }},scopedSlots:_vm._u([{key:"renderItem",fn:function(ref){
var label = ref.label;
return [_c('div',[_vm._v(" "+_vm._s(label)+" ")])]}}])}),_c('multi-list',{attrs:{"componentId":"monthFilter","filterLabel":this.$t('labels.month'),"title":this.$t('labels.month-ticket-registered'),"dataField":"month.raw","className":"horizontal-filter month-filter","sortBy":"asc","size":12,"showSearch":false,"URLParams":true,"transformData":_vm.sortMonthByLabel,"react":{ and: _vm.getOtherFilterIds('monthFilter') }},scopedSlots:_vm._u([{key:"renderItem",fn:function(ref){
var label = ref.label;
var count = ref.count;
return [_c('div',[_vm._v(" "+_vm._s(label)+" ")])]}}])})],1)])]),_c('div',{staticClass:"col-lg-12 col-xl-3 order-lg-1 order-xl-1"},[_c('div',{staticClass:"widget widget-facets statistics-vertical"},[_c('div',{staticClass:"widget-header mb-3"},[_c('div',{staticClass:"widget-header-label"},[_c('h3',[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"fas fa-circle-notch fa-spin"}),_vm._v(_vm._s(_vm.$t('labels.filtration')))])]),_c('div',{staticClass:"widget-header-toolbar"},[_c('div',{staticClass:"actions"})])]),_c('reactive-component',{attrs:{"componentId":"ticketFilterDefault","URLParams":false,"react":{ and: _vm.getOtherFilterIds('ticketFilterDefault') },"customQuery":_vm.defaultQuery}}),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","title":"Stödorganisation","size":150,"componentId":"policeSupportOrgFilter","filterLabel":"Stödorganisation","dataField":this.$field('police_support_org') + '.raw',"react":{ and: _vm.getOtherFilterIds('policeSupportOrgFilter') }}})],1),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","title":this.$t('labels.gender'),"componentId":"genderFilter","filterLabel":this.$t('labels.gender'),"dataField":this.$field('gender') + '.raw',"react":{ and: _vm.getOtherFilterIds('genderFilter') }}})],1),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","title":this.$t('labels.age-group'),"componentId":"ageFilter","filterLabel":this.$t('labels.age-group'),"dataField":this.$field('age') + '.raw',"transformData":_vm.customSortAge,"react":{ and: _vm.getOtherFilterIds('ageFilter') }}})],1),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","componentId":"categoryFilter","filterLabel":this.$t('labels.category'),"title":this.$t('labels.category'),"dataField":this.$field('category') + '.raw',"react":{ and: _vm.getOtherFilterIds('categoryFilter') }}})],1),_c('v-guard',{attrs:{"permissions":['ticket-access-all-tickets', 'ticket-view-formedla_externt'],"all":true}},[_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","title":"Status","componentId":"ticketStatusFilter","filterLabel":"Status","dataField":this.$field('ticketstatus') + '.raw',"react":{ and: _vm.getOtherFilterIds('ticketStatusFilter') }}})],1)]),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","title":this.$t('labels.first-contact'),"componentId":"firstContactFilter","filterLabel":this.$t('labels.first-contact'),"dataField":this.$field('first_contact') + '.raw',"react":{ and: _vm.getOtherFilterIds('firstContactFilter') }}})],1),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","componentId":"crimeFilter","size":120,"title":this.$t('labels.crime'),"filterLabel":this.$t('labels.crime'),"dataField":this.$field('crime') + '.raw',"react":{ and: _vm.getOtherFilterIds('crimeFilter') }}})],1),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","title":this.$t('labels.special-circumstances'),"componentId":"crimeRelationSubFilter","filterLabel":this.$t('labels.special-circumstances'),"nestedField":"crime_relation","dataField":this.$field('crime_relation.label') + '.raw',"react":{ and: _vm.getOtherFilterIds('crimeRelationSubFilter') }}})],1),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","title":this.$t('labels.special-events'),"componentId":"specialEventSubFilter","filterLabel":this.$t('labels.special-events'),"dataField":this.$field('special_event') + '.raw',"react":{ and: _vm.getOtherFilterIds('specialEventSubFilter') }}})],1),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","size":200,"title":this.$t('labels.language'),"componentId":"languageFilter","filterLabel":this.$t('labels.language'),"dataField":this.$field('language') + '.raw',"react":{ and: _vm.getOtherFilterIds('languageFilter') }}})],1),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","size":200,"componentId":"officeFilter","title":this.$t('labels.victim-support-centre'),"filterLabel":this.$t('labels.victim-support-centre'),"dataField":"office.raw","react":{ and: _vm.getOtherFilterIds('officeFilter') }}})],1),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","size":400,"componentId":"municipalityFilter","title":this.$t('labels.municipality'),"filterLabel":this.$t('labels.municipality'),"dataField":"municipality.raw","react":{ and: _vm.getOtherFilterIds('municipalityFilter') }}})],1),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","size":1000,"componentId":"userSubFilter","title":this.$t('labels.administrator'),"filterLabel":this.$t('labels.administrator'),"nestedField":"users","dataField":"users.name.raw","react":{ and: _vm.getOtherFilterIds('userSubFilter') }}})],1)],1)])]),_c('div',{staticClass:"col-lg-12 col-xl-9 order-lg-1 order-xl-1"},[_c('reactive-component',{attrs:{"componentId":"myColorPicker","URLParams":true,"react":{ and: _vm.getOtherFilterIds('') },"defaultQuery":function () {

								var excludedYears = ['2017', '2018', '2019', '2020'];
								var queryObject = {
									runtime_mappings: {
										'date.month_of_years': {
											type: 'long',
											script: 'emit(doc[\'created_at\'].value.getMonthValue())',
										},
									},
									query: {
										bool: {
											must_not: [
											],
										},
									},
									aggs: {
										crimes: {
											terms: {
												field: this$1.$field('crime') + '.raw',
												order: {
													_key: 'asc',
												},
												size: 100,
											},
											aggs: {
												year: {
													terms: {
														field: 'year.raw',
														order: {
															_key: 'asc',
														},
														min_doc_count: 0,
														size: 20,
													},
													aggs: {
														gender: {
															terms: {
																field: 'gender.raw',
																order: {
																	_key: 'asc',
																},
																size: 20,
															},
														},
													},
												},
											},
										},
										office: {
											terms: {
												field: 'office.raw',
												order: {
													_key: 'asc',
												},
												size: 100,
											},
											aggs: {
												year: {
													terms: {
														field: 'year.raw',
														order: {
															_key: 'asc',
														},
														min_doc_count: 0,
														size: 20,
													},
												},
											},
										},
                                        age: {
											terms: {
												field: this$1.$field('age') + '.raw',
												order: {
													_key: 'asc',
												},
											},
											aggs: {
												year: {
													terms: {
														field: 'year.raw',
														order: {
															_key: 'asc',
														},
														min_doc_count: 0,
														size: 20,
													},
												},
											},
										},
										gender: {
											terms: {
												field: this$1.$field('gender') + '.raw',
												order: {
													_key: 'asc',
												},
											},
											aggs: {
												year: {
													terms: {
														field: 'year.raw',
														order: {
															_key: 'asc',
														},
														min_doc_count: 0,
														size: 20,
													},
												},
											},
										},
										month: {
											terms: {
												field: 'date.month_of_years',
												order: {
													_key: 'asc',
												},
												size: 12,
											},
											aggs: {
												year: {
													terms: {
														field: 'year.raw',
														order: {
															_key: 'asc',
														},
														min_doc_count: 0,
														size: 20,
													},
												},
											},
										},
										quarter: {
											terms: {
												field: 'quarter.raw',
												order: {
													_key: 'asc',
												},
												size: 4,
											},
											aggs: {
												year: {
													terms: {
														field: 'year.raw',
														order: {
															_key: 'asc',
														},
														min_doc_count: 0,
														size: 20,
													},
												},
											},
										},
										category: {
											terms: {
												field: this$1.$field('category') + '.raw',
												order: {
													_key: 'asc',
												},
											},
											aggs: {
												year: {
													terms: {
														field: 'year.raw',
														order: {
															_key: 'asc',
														},
														min_doc_count: 0,
														size: 20,
													},
												},
											},
										},
										police_support_org: {
											terms: {
												field: this$1.$field('police_support_org') + '.raw',
												order: {
													_key: 'asc',
												},
												size: 200,
											},
											aggs: {
												year: {
													terms: {
														field: 'year.raw',
														order: {
															_key: 'asc',
														},
														min_doc_count: 0,
														size: 20,
													},
												},
											},
										},
                                        language: {
											terms: {
												field: this$1.$field('language') + '.raw',
												order: {
													_key: 'asc',
												},
												size: 100,
											},
											aggs: {
												year: {
													terms: {
														field: 'year.raw',
														order: {
															_key: 'asc',
														},
														min_doc_count: 0,
														size: 20,
													},
												},
											},
										},
										municipality: {
											terms: {
												field: 'municipality.raw',
												order: {
													_key: 'asc',
												},
												size: 400,
											},
											aggs: {
												year: {
													terms: {
														field: 'year.raw',
														order: {
															_key: 'asc',
														},
														min_doc_count: 0,
														size: 20,
													},
												},
											},
										},
										users: {
											nested: {
												path: 'users',
											},
											aggs: {
												user: {
													terms: {
														field: 'users.name.raw',
														order: {
															_key: 'asc',
														},
														size: 1000,
													},
													aggs: {
														reverted: {
															reverse_nested: {},
															aggs: {
																year: {
																	terms: {
																		field: 'year.raw',
																		order: {
																			_key: 'asc',
																		},
																		min_doc_count: 0,
																		size: 20,
																	},
																},
															},
														},
													},
												},
											},
										},
										crime_relations: {
											nested: {
												path: 'crime_relation',
											},
											aggs: {
												relation: {
													terms: {
														field: 'crime_relation.label.raw',
														order: {
															_key: 'asc',
														},
														size: 100,
													},
													aggs: {
														reverted: {
															reverse_nested: {},
															aggs: {
																year: {
																	terms: {
																		field: 'year.raw',
																		order: {
																			_key: 'asc',
																		},
																		min_doc_count: 0,
																		size: 20,
																	},
																},
															},
														},
													},
												},
											},
										},
										firstcontact: {
											terms: {
												field: this$1.$field('first_contact') + '.raw',
												order: {
													_key: 'asc',
												},
											},
											aggs: {
												year: {
													terms: {
														field: 'year.raw',
														order: {
															_key: 'asc',
														},
														min_doc_count: 0,
														size: 20,
													},
												},
											},
										},
										special_event: {
											terms: {
												field: this$1.$field('special_event') + '.raw',
												order: {
													_key: 'asc',
												},
											},
											aggs: {
												year: {
													terms: {
														field: 'year.raw',
														order: {
															_key: 'asc',
														},
														min_doc_count: 0,
														size: 20,
													},
												},
											},
										},
										actions: {
											nested: {
												path: 'actions',
											},
											aggs: {
												action_parent: {
													terms: {
														field: 'actions.parent_label.raw',
														exclude: ['Intervju', 'System', 'Kommentar'],
														order: {
															_key: 'asc',
														},
														size: 200,
													},
													aggs: {
														action_child: {
															terms: {
																field: 'actions.child_label.raw',
																order: {
																	_key: 'asc',
																},
																size: 200,
															},
															aggs: {


																nested_actions: {

																	reverse_nested: { path: 'actions' },
																	aggs: {
																		nested_actions_years: {
																			reverse_nested: { path: 'actions' },
																			aggs: {
																				year: {
																					terms: {
																						field: 'actions.year',
																						order: {
																							_key: 'asc',
																						},
																						min_doc_count: 0,
																						size: 20,
																					},
																					aggs: {
																						nested_action_time: {
																							reverse_nested: { path: 'actions' },
																							aggs: {
																								action_time_year: {
																									sum: {
																										field: 'actions.action_time',
																									},


																								},
																							}
																						}
																					}
																				}
																			}

																		}

																	}


																},


															},
														},
													},
												},
											},
										},
										total_year: {
											terms: {
												field: 'year.raw',
												order: {
													_key: 'asc',
												},
												min_doc_count: 0,
												size: 20,
											},
										},

									},
								};
								if (!this$1.$store.getters.permissions.includes('ticket-view-formedla_externt')) {
									queryObject.query.bool.must_not.push({ match: { ticketstatus: 'Förmedlad externt' } });
								}
								return queryObject;
							}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
							var aggregations = ref.aggregations;
							var hits = ref.hits;
							var setQuery = ref.setQuery;
return _c('div',{},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('statistic-widget-total',{attrs:{"yearsSelected":_vm.yearsSelected,"data":aggregations.total_year.buckets,"title":_vm.$t('labels.total')}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"data":aggregations.quarter.buckets,"title":_vm.$t('labels.quarter')}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"data":aggregations.month.buckets,"title":_vm.$t('labels.month')}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"data":aggregations.gender.buckets,"title":_vm.$t('labels.gender')}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"data":_vm.customSortAge(aggregations.age.buckets),"title":_vm.$t('labels.age-group')}},[_vm._v(">")])],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"data":aggregations.category.buckets,"title":_vm.$t('labels.category')}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"data":aggregations.firstcontact.buckets,"title":_vm.$t('labels.first-contact')}},[_vm._v(">")])],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"data":aggregations.crimes.buckets,"title":_vm.$t('labels.crime')}},[_vm._v(">")])],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"data":aggregations.crime_relations.relation.buckets,"title":_vm.$t('labels.special-circumstances')}},[_vm._v(">")])],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"data":aggregations.police_support_org.buckets,"title":"Stödorganisation"}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"data":aggregations.special_event.buckets,"title":_vm.$t('labels.special-events')}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"data":aggregations.language.buckets,"title":_vm.$t('labels.language')}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"data":aggregations.office.buckets,"title":_vm.$t('labels.victim-support-centre')}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"data":aggregations.municipality.buckets,"title":_vm.$t('labels.municipality')}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"data":aggregations.users.user.buckets,"infoBox":'Ärenden avd Statistik - aggregerat fält Handläggare rubrik',"title":_vm.$t('labels.administrator')}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget-hierarchical',{attrs:{"yearsSelected":_vm.yearsSelected,"data":aggregations.actions.action_parent.buckets,"hideParent":[],"title":"Antal händelser"}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget-action-time',{attrs:{"yearsSelected":_vm.yearsSelected,"data":aggregations.actions.action_parent.buckets,"hideParent":[],"title":"Nedlagd tid i minuter"}})],1)])])}}])})],1)],1)]),_c('ScrollTopArrow')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }